import RoomTypeAccordion from './RoomTypeAccordion'

export default RoomTypeAccordion
